import type { ModelType } from 'src/types'

export type InvokeKey =
  | 'editNode'
  | 'init'
  | 'saveFlow'
  | 'editFlow'
  | 'newNode'
  | 'delNode'

export interface InvokeDataType {
  editNode: {
    id: number
    typeName: string
    type: string
    nodeName: string
  }
  editFlow: {
    id: number
    typeName: string
  }
  saveFlow: {
    [key: string]: any
  }
  init: {
    [key: string]: any
  }
}

export function invokeAction(model: ModelType, type: InvokeKey, data: any) {
  // console.log('invokeAction ====>', model, type, data);
  switch (type) {
    case 'editNode':
    case 'saveFlow':
    case 'newNode':
    case 'delNode':
    case 'editFlow':
    case 'init':
      model.invokeAsync(type, data)
  }
}
